export enum AccountStatus {
  ACTIVE = 1,
  NOT_VERIFIED = 2,
  BLOCKED = 3,
  UNCONFIRMED = 4,
}

const ACCOUNT_STATUS_LABELS: Record<number, string> = {
  [AccountStatus.ACTIVE]: 'ACTIVE',
  [AccountStatus.NOT_VERIFIED]: 'NOT_VERIFIED',
  [AccountStatus.BLOCKED]: 'BLOCKED',
  [AccountStatus.UNCONFIRMED]: 'UNCONFIRMED',
};

export const mapAccountStatus = (status: string | number | undefined): string => {
  if (typeof status === 'number') {
    return ACCOUNT_STATUS_LABELS[status] ?? String(status);
  }
  return status ?? '';
};
